// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPnlMetricDto
 */
export interface IPnlMetricDto {
    /**
     * 
     * @type {number}
     * @memberof IPnlMetricDto
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof IPnlMetricDto
     */
    amount?: number;
}

/**
 * Check if a given object implements the IPnlMetricDto interface.
 */
export function instanceOfIPnlMetricDto(value: object): value is IPnlMetricDto {
    return true;
}

export function IPnlMetricDtoFromJSON(json: any): IPnlMetricDto {
    return IPnlMetricDtoFromJSONTyped(json, false);
}

export function IPnlMetricDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPnlMetricDto {
    if (json == null) {
        return json;
    }
    return {
        
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function IPnlMetricDtoToJSON(json: any): IPnlMetricDto {
    return IPnlMetricDtoToJSONTyped(json, false);
}

export function IPnlMetricDtoToJSONTyped(value?: IPnlMetricDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'percentage': value['percentage'],
        'amount': value['amount'],
    };
}

